import { render, staticRenderFns } from "./ChatPinnedMessagesDialog.vue?vue&type=template&id=675cf897&scoped=true"
import script from "./ChatPinnedMessagesDialog.vue?vue&type=script&lang=js"
export * from "./ChatPinnedMessagesDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatPinnedMessagesDialog.vue?vue&type=style&index=0&id=675cf897&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675cf897",
  null
  
)

export default component.exports